import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import ProgressBar from 'react-bootstrap/ProgressBar';
import UncheckIcon from '@material-ui/icons/FiberManualRecordOutlined';
import CheckIcon from '@material-ui/icons/CheckCircleOutlineOutlined';
import cx from 'classnames';
import statusConfing from 'config/orderStatus.json';

const OrderProgressStatus = ({ statusPath, currentStatusId }) => {
    const currentSelectedId = currentStatusId ? statusConfing.filter((f) => f.id === currentStatusId) : null;

    return (
        <Fragment>
            <ProgressBar
                now={currentSelectedId && currentSelectedId[0] ? currentSelectedId[0].value : 0}
                className="order__progressbar"
            />

            {statusPath &&
                statusPath.map(([id, status]) => {
                    const isActiveStatusLabel = id === currentStatusId;
                    const selected = statusConfing.filter((f) => f.id === id) || [{ value: 0, label: null }];
                    const value = selected[0] ? selected[0].value : null;
                    const label = selected[0] ? selected[0].label : null;
                    const statusLabelClass = cx('status__label', {
                        'status__label--active': isActiveStatusLabel,
                    });
                    const iconClass = cx('status__label--icon', {
                        actived: status,
                    });

                    return (
                        label && (
                            <div key={`status-${id}`} className={statusLabelClass} style={{ left: `${value}%` }}>
                                {isActiveStatusLabel ? (
                                    <CheckIcon className="status__label--icon" />
                                ) : (
                                    <UncheckIcon className={iconClass} />
                                )}
                                <span className="status__label--name">{label}</span>
                            </div>
                        )
                    );
                })}
        </Fragment>
    );
};

OrderProgressStatus.propTypes = {
    currentStatusId: PropTypes.string.isRequired,
    statusPath: PropTypes.array.isRequired,
};

export default OrderProgressStatus;
